import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '@/lib/provider/AuthProvider'

export const CREATE_COMPANY_PATH = '/settings/create-customer'

/** Whether the signed-in user belongs to a company yet. */
export const useHasCompany = (): boolean => {
  const [auth] = useAuth()

  return Boolean(auth.user?.customer_id)
}

/**
 * Sends a user without a company to the company setup, returning whether the
 * caller still has one. Pages that describe a company cannot render without
 * it, and the customer_optional flag lets such a user reach them.
 */
const useRequireCompany = (): boolean => {
  const navigate = useNavigate()
  const hasCompany = useHasCompany()

  useEffect(() => {
    if (hasCompany) return

    localStorage.setItem('redirect', window.location.pathname)
    navigate(CREATE_COMPANY_PATH, { replace: true })
  }, [hasCompany, navigate])

  return hasCompany
}

export default useRequireCompany
